export default "__VITE_ASSET__kBTyB73M__"